import { Currency } from '@ui/src';

export enum MfaType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  PUSH = 'PUSH',
  TOTP = 'TOTP',
}

export interface MfaToken {
  token: string;
  userId: string;
  expiresAt: string;
}

export interface PaymentType {
  createdAt: string;
  enabled: boolean;
  id: string;
  name: string;
  paymentType: string;
  visibleToClients: boolean;
  currencies: {
    edges: {
      node: Currency;
    }[];
  };
}

export interface PurposeCodeSettings {
  id: string;
  purposeCodeType: string;
  paymentCategoryId: string;
  bankCountry: string;
  currenciesIds: string[];
  required?: boolean;
}

export interface PurposeCodeListItem {
  code: string;
  description: string;
  id: string;
  type: string;
}
